import {Injectable} from "@angular/core";
import {AbstractBaseComponent} from "../app.baseComponent";
import {CanActivate, Router} from "@angular/router";
import {Observable} from "rxjs";
import {map, tap} from "rxjs/operators";
import {AuthenticationHelper} from "../helpers/authenticationHelper";
import {UtilityHelper} from "../helpers/utilityHelper";
import {OnboardingProgressService} from "../pages/gamification/services/onboarding-progress.service";
import { shouldRedirectToWaitingListFromStorage } from "../helpers/openAccessWaitingList.helper";
import { isTransitionedFromMentorHub } from "../pages/gamification/experience-mode";

@Injectable()
export class PreLoginGuard extends AbstractBaseComponent implements CanActivate {
    constructor(
        private authService: AuthenticationHelper,
        private utility: UtilityHelper,
        private route: Router,
        private onboarding: OnboardingProgressService,
    ) {
        super();
    }

    canActivate(): boolean | Observable<boolean> {
        if (!this.authService.isLoggedIn()) {
            if (
                this.utility.myDomain === this.LOCAL_DOMAIN ||
                this.utility.myDomain === this.BRILLIANTCLUB_DOMAIN ||
                this.utility.myDomain === this.KNOWLEDGE_DOMAIN
            ) {
                return true;
            } else if (this.utility.myDomain != this.MENTORING_DOMAIN) {
                this.utility.navigateToMentoringDomain();
                return false;
            }
            return true;
        }

        if (this.utility.myDomain === this.KNOWLEDGE_DOMAIN) {
            return true;
        }

        // Hub mentors who opened a project from the hub must stay in that
        // project — do not treat `/` as "send them back to Mentor Hub".
        if (
            this.utility.getItem('role') === 'mentor' &&
            this.utility.hasMentorHubAccess &&
            !isTransitionedFromMentorHub(this.utility)
        ) {
            this.route.navigate(['/mentor-hub/dashboard']);
            return false;
        }

        return this.onboarding.ensureSession().pipe(
            tap(() => this.redirectToUser()),
            map(() => false),
        );
    }

    redirectToUser() {
        const showWaitingList = shouldRedirectToWaitingListFromStorage(this.utility);

        if (this.utility.myDomain == this.LOCAL_DOMAIN) {
            if (showWaitingList) {
                this.route.navigate(['/waiting-list']);
            } else {
                this.route.navigate(this.onboarding.landingRoute());
            }
        } else if (this.utility.myDomain == this.MENTORING_DOMAIN) {
            if (showWaitingList) {
                this.route.navigate(['/waiting-list']);
            } else {
                this.route.navigate(this.onboarding.landingRoute());
            }
        } else if (this.utility.myDomain == this.ADMIN_DOMAIN) {
            this.route.navigate(['/projects']);
        } else if (this.utility.myDomain == this.BRILLIANTCLUB_DOMAIN) {
            this.route.navigate(this.utility.channelsRouteCommands());
        }
    }

}
